export default {
  name: 'Розширення: Малювання',
  buttons: [
    {
      title: 'Малювання',
      key: '[Пробіл / колесо миші + перетягування]'
    }
  ]
}
